import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import './getallverses.css'
import Navbar from './components/Navbar';
import Footer from './Footer';

function GetAllVerses() {
    let navigate = useNavigate()
    const [verses,setVerses] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    let param = useParams();
    useEffect(()=>{
        setIsLoading(true);
        fetch('https://bhagavad-gita3.p.rapidapi.com/v2/chapters/' + param.id + '/verses/',{
            method: 'GET',
            headers: {
                'X-RapidAPI-Key': '4034969b2cmshf9e4ab0b6a68552p1e99cajsn6474fa44b7c4',
                'X-RapidAPI-Host': 'bhagavad-gita3.p.rapidapi.com'
            }
        })
        .then((res)=>{
            return res.json();
        })
        .then((res)=>{
            // console.log(res)
            setVerses(res)
        })
        .catch(error => console.log(error))
        .finally(() => setIsLoading(false))
        
    },[param.id])

    if (isLoading) {
        return <div className="d-flex justify-content-center center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>;
    }

  return (
    <>
    <Navbar/>
    <div className='verse_container'>
        <button className='back-btn' onClick={() => navigate(-1)}><i className="fa-solid fa-arrow-left"></i><span>Back</span></button>
        {verses?.map((verse) => (
            <>
            <Link to={'/chapters/' + verse.chapter_number + '/verses/' + verse.verse_number+'/'} className='link'>
            <div className="card border-0 verse-list-container" key={verse.id}>
                <div className="card-body">
                    <h5 className="card-title">{verse.text}</h5>
                    <h4 className='translation-title'><b>Translation:</b></h4>
                    <h4 className='hindi-translation'>{verse.translations.find(obj => obj.language === 'hindi').description}</h4>
                </div>
            </div>  
            </Link>
            </>
        ))}
        <button className='back-btn' onClick={() => navigate(-1)}><i className="fa-solid fa-arrow-left"></i><span>Back</span></button>
    </div>
    <Footer/>
    </>
  )
}

export default GetAllVerses

